import {FETCH_SLIDER} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_SLIDER:
            return action.payload;
        default:
            return state;
    }
};